import { UniswapV3AbstractTrade } from 'src/features/on-chain/calculation-manager/providers/dexes/common/uniswap-v3-abstract/uniswap-v3-abstract-trade';

export class UniSwapV3EthereumTrade extends UniswapV3AbstractTrade {}
